<template>
  <div>
    <van-tabs v-model="activeTab" @change="changeActiveTab">
      <van-tab title="按订单编号筛选"></van-tab>
      <van-tab title="按买家账号筛选"></van-tab>
    </van-tabs>
    <div class="filter_wrapper">
      <van-field
        :autosize="{ maxHeight: 242 }"
        style="height:262px"
        v-model="filterVal"
        rows="10"
        type="textarea"
        :placeholder="filterPlaceHolder"
        :border="false"
      />
      <van-loading
        size="24px"
        vertical
        type="spinner"
        color="#1989fa"
        v-show="spinning"
        style="position: absolute;top:200px;left:0;right:0;bottom:0"
        >拉取中...</van-loading
      >
      <div class="btn_wrapper">
        <van-button
          round
          type="info"
          class="buy_btn"
          color="#f93244"
          @click="handleFilterOrder"
          >确认添加</van-button
        >
      </div>
      <div class="cancel_btn" @click="handleCancel">取消</div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { storeOrders } from '@/api';
export default {
  data() {
    return {
      activeTab: '0',
      filterVal: '',
      filterPlaceHolder:
        '粘贴多个订单编号，需换行，不输入则筛选全部\n示例：\n11111111\n22222222',
      firstTypeId: '',
      store: {},
      spinning: false,
      errorOutputs: []
    };
  },
  created() {
    this.firstTypeId = Vue.ls.get('firstType');
    this.store = Vue.ls.get('store');
  },
  methods: {
    handleFilterOrder() {
      if (!this.store.id) {
        return this.$toast.fail('请先绑定店铺');
      }
      const timeStamp = new Date().getTime();
      let lasttimeStamp;
      //拼多多拉取一周的订单
      if (this.firstTypeId == 'PDD') {
        lasttimeStamp = timeStamp - 1000 * 3600 * 24 * 7;
      } else {
        lasttimeStamp = timeStamp - 1000 * 3600 * 24 * 30;
      }
      this.spinning = true;
      const params = {
        createdStart: lasttimeStamp,
        createdEnd: timeStamp,
        noteColor: this.store.tag //todo
      };
      storeOrders(this.store.id, params)
        .then((res) => {
          if (res.success) {
            this.spinning = false;
            const data = res.data.list;
            if (data.length == 0) {
              this.$toast.fail('您的店铺没有订单');
              setTimeout(() => {
                Vue.ls.set('addressList', []);
                this.$router.push('/buy');
              }, 1000);
            } else {
              data.forEach((item, index) => {
                item.id = index;
                item.key = index + 1;
                item.addressStr =
                  item.province + item.city + item.county + item.address;
              });
              let result = this.filterOrder(data);
              //完全筛不到
              if (result.length == 0) {
                this.$toast.fail('您筛选的订单不存在');
                setTimeout(() => {
                  Vue.ls.set('addressList', result);
                  this.$router.push('/buy');
                }, 1000);
              }
              //部分筛不到
              if (result.length > 0 && this.errorOutputs.length > 0) {
                this.$dialog({
                  message: '筛选不到的订单：' + this.errorOutputs.toString()
                }).then(() => {
                  Vue.ls.set('addressList', result);
                  this.$router.push('/buy');
                });
              }
              //完全筛选到了
              if (result.length > 0 && this.errorOutputs.length == 0) {
                Vue.ls.set('addressList', result);
                this.$router.push('/buy');
              }
            }
          } else {
            this.spinning = false;
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
          this.spinning = false;
          this.$toast.fail('出错啦～');
        });
    },
    handleCancel() {
      this.$router.push({ name: 'address', query: { index: 1 } });
    },
    filterOrder(outputs) {
      const arr = this.filterVal
        .trim()
        .split('\n')
        .filter((address) => address.trim() !== '');
      const newOutputs = JSON.parse(JSON.stringify(outputs));

      let data = [];
      if (arr.length) {
        arr.forEach((item, index) => {
          item = item.replace(/\s+/g, ''); //替换空格
          if (this.activeTab == 0) {
            // 按订单编号筛选
            const target = newOutputs.filter((ele) => ele.orderNo === item);
            if (!target.length) {
              this.errorOutputs.push(item);
              return;
            }
            data.push(target[0]);
          } else {
            // 按买家账号筛选
            const target = newOutputs.filter((ele) => ele.buyer === item);
            if (!target.length) {
              this.errorOutputs.push(item);
              return;
            }
            data.push(target[0]);
          }
        });
      } else {
        data = JSON.parse(JSON.stringify(newOutputs));
      }
      //筛选后重新排序
      data.forEach((item, index) => {
        item.id = index;
        item.key = index + 1;
      });
      this.filterVal = '';
      return data;
    },
    changeActiveTab(val) {
      if (val == 0) {
        this.filterPlaceHolder =
          '粘贴多个订单编号，需换行，不输入则筛选全部\n示例：\n1111111\n22222222';
      } else {
        this.filterPlaceHolder =
          '粘贴多个买家账号，需换行，不输入则筛选全部\n示例：\n买家账号1\n买家账号2';
      }
    }
  }
};
</script>

<style lang="less" scoped>
.filter_wrapper {
  padding-top: 3.2vw;
  background: #f7f8fa;
  height: calc(100vh - 44px);
  position: relative;
}
.btn_wrapper {
  display: flex;
  justify-content: center;
  margin-top: 54.4vw;
  margin-bottom: 4.267vw;
  .buy_btn {
    width: 91.467vw;
    height: 11.733vw;
  }
}
.cancel_btn {
  font-size: 4.533vw;
  text-align: center;
  color: rgba(0, 0, 0, 0.85);
}
</style>
